export interface RatgeberFAQ {
  question: string;
  answer: string;
}

export interface RatgeberRemedy {
  name: string;
  benefit: string;
  application: string;
}

export interface RatgeberContent {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  h1: string;
  intro: string;
  causes: string[];
  remedies: RatgeberRemedy[];
  tips: string[];
  whenToSeeDoctor: string[];
  faqs: RatgeberFAQ[];
  relatedTopics: string[];
}

export const ratgeberData: Record<string, RatgeberContent> = {
  "erkaeltung": {
    slug: "erkaeltung",
    title: "Erkältung natürlich behandeln",
    metaTitle: "Erkältung natürlich behandeln: 7 wirksame Hausmittel | Naturkraft",
    metaDescription: "Erkältung schnell loswerden mit bewährten Naturmitteln. Entdecke Ingwer, Holunder & Co. – sanft, wirksam und ohne Nebenwirkungen.",
    h1: "Erkältung natürlich behandeln: Diese Hausmittel helfen wirklich",
    intro: "Eine Erkältung kommt oft zur Unzeit und macht uns tagelang zu schaffen. Die gute Nachricht: Mit den richtigen Naturmitteln kannst du die Symptome lindern und dein Immunsystem bei der Heilung unterstützen – ganz ohne aggressive Medikamente.",
    causes: [
      "Über 200 verschiedene Viren können Erkältungen auslösen",
      "Geschwächtes Immunsystem durch Stress oder Schlafmangel",
      "Trockene Heizungsluft reizt die Schleimhäute",
      "Ansteckung durch Tröpfcheninfektion"
    ],
    remedies: [
      { name: "Ingwer", benefit: "Wärmt von innen, wirkt antiviral und entzündungshemmend", application: "Als frischer Tee mit Honig und Zitrone mehrmals täglich trinken" },
      { name: "Holunderbeeren", benefit: "Verkürzt nachweislich die Erkältungsdauer um bis zu 4 Tage", application: "Als Sirup oder Saft bei ersten Symptomen einnehmen" },
      { name: "Echinacea", benefit: "Stärkt die Immunabwehr und kann Erkältungen vorbeugen", application: "Als Tinktur oder Tabletten gemäß Packungsanweisung" },
      { name: "Thymian", benefit: "Löst Schleim und beruhigt den Hustenreiz", application: "Als Tee oder Inhalation mit heißem Wasser" },
      { name: "Vitamin C + Zink", benefit: "Unterstützt das Immunsystem bei der Virusabwehr", application: "Hochdosiert bei ersten Symptomen einnehmen" }
    ],
    tips: [
      "Viel trinken – mindestens 2-3 Liter warme Getränke täglich",
      "Ausreichend schlafen und dem Körper Ruhe gönnen",
      "Regelmäßig lüften für frische, befeuchtete Luft",
      "Hühnersuppe – wissenschaftlich belegt entzündungshemmend",
      "Nasenspülung mit Salzwasser hält Schleimhäute feucht"
    ],
    whenToSeeDoctor: [
      "Fieber über 39°C, das länger als 3 Tage anhält",
      "Starke Halsschmerzen mit Schluckbeschwerden",
      "Atemnot oder pfeifende Atemgeräusche",
      "Symptome verschlechtern sich nach einer Woche"
    ],
    faqs: [
      { question: "Wie lange dauert eine Erkältung normalerweise?", answer: "Eine typische Erkältung dauert 7-10 Tage. Mit den richtigen Naturmitteln können die Symptome jedoch deutlich schneller abklingen." },
      { question: "Kann ich eine Erkältung mit Naturmitteln verhindern?", answer: "Ja, regelmäßige Einnahme von Echinacea, Vitamin C und Zink kann das Immunsystem stärken und die Anfälligkeit für Erkältungen reduzieren." },
      { question: "Hilft Schwitzen bei Erkältung?", answer: "Schwitzen kann helfen, sollte aber nicht erzwungen werden. Lindenblütentee fördert sanftes Schwitzen und unterstützt den Heilungsprozess." }
    ],
    relatedTopics: ["fieber", "kopfschmerzen", "husten", "halsschmerzen"]
  },

  "fieber": {
    slug: "fieber",
    title: "Fieber natürlich senken",
    metaTitle: "Fieber senken mit Hausmitteln: Sanfte & wirksame Methoden | Naturkraft",
    metaDescription: "Fieber natürlich senken ohne Medikamente. Bewährte Hausmittel wie Wadenwickel, Lindenblütentee & mehr – sicher für Erwachsene und Kinder.",
    h1: "Fieber natürlich senken: Bewährte Hausmittel für die ganze Familie",
    intro: "Fieber ist keine Krankheit, sondern eine wichtige Abwehrreaktion des Körpers. Statt es sofort zu unterdrücken, können sanfte Naturmittel helfen, es zu regulieren und den Heilungsprozess zu unterstützen.",
    causes: [
      "Virale oder bakterielle Infektionen",
      "Immunreaktion auf Krankheitserreger",
      "Entzündungen im Körper",
      "Nach Impfungen als normale Reaktion"
    ],
    remedies: [
      { name: "Lindenblütentee", benefit: "Schweißtreibend und fiebersenkend, sehr sanft", application: "3-4 Tassen täglich warm trinken" },
      { name: "Holunderblütentee", benefit: "Traditionelles Fiebermittel, immunstärkend", application: "Mit Honig gesüßt mehrmals täglich trinken" },
      { name: "Weidenrinde", benefit: "Enthält natürliches Salicin (ähnlich wie Aspirin)", application: "Als Tee oder Extrakt bei Bedarf einnehmen" },
      { name: "Wadenwickel", benefit: "Senkt Fieber sanft um 0,5-1°C", application: "Lauwarme (nicht kalte!) Tücher um die Waden wickeln" }
    ],
    tips: [
      "Viel trinken – Fieber entzieht dem Körper Flüssigkeit",
      "Leichte Kleidung und dünne Decke, nicht warm einpacken",
      "Ruhe und Schlaf sind die beste Medizin",
      "Zimmertemperatur auf 18-20°C halten",
      "Leichte Kost wie Brühe oder Obst"
    ],
    whenToSeeDoctor: [
      "Fieber über 40°C bei Erwachsenen",
      "Fieber über 38,5°C bei Säuglingen unter 3 Monaten",
      "Fieber dauert länger als 3 Tage",
      "Begleitsymptome wie Nackensteife, Ausschlag oder Verwirrtheit",
      "Fieberkrämpfe bei Kindern"
    ],
    faqs: [
      { question: "Ab wann spricht man von Fieber?", answer: "Ab 38°C spricht man von erhöhter Temperatur, ab 38,5°C von Fieber und ab 39,5°C von hohem Fieber." },
      { question: "Sollte man Fieber immer senken?", answer: "Nein, leichtes Fieber bis 38,5°C sollte man oft nicht senken, da es dem Körper hilft, Krankheitserreger zu bekämpfen. Erst bei höherem Fieber oder starkem Unwohlsein ist Senken sinnvoll." },
      { question: "Sind Wadenwickel für Kinder geeignet?", answer: "Ja, aber nur bei warmem Körper und Fieber über 39°C. Bei kalten Händen und Füßen oder Schüttelfrost sind Wadenwickel nicht geeignet." }
    ],
    relatedTopics: ["erkaeltung", "grippe", "immunsystem-staerken", "husten"]
  },

  "kopfschmerzen": {
    slug: "kopfschmerzen",
    title: "Kopfschmerzen natürlich lindern",
    metaTitle: "Kopfschmerzen natürlich lindern: 8 Hausmittel ohne Tabletten | Naturkraft",
    metaDescription: "Kopfschmerzen schnell loswerden ohne Medikamente. Pfefferminzöl, Magnesium & bewährte Hausmittel – sofortige Linderung bei Spannungskopfschmerz.",
    h1: "Kopfschmerzen natürlich lindern: Wirksame Alternativen zu Schmerztabletten",
    intro: "Kopfschmerzen gehören zu den häufigsten Beschwerden überhaupt. Doch statt immer zur Tablette zu greifen, gibt es wirksame Naturmittel, die oft genauso schnell helfen – ohne Nebenwirkungen und Gewöhnungseffekt.",
    causes: [
      "Verspannungen in Nacken und Schultern",
      "Dehydration und Flüssigkeitsmangel",
      "Stress und psychische Belastung",
      "Bildschirmarbeit und Augenbelastung",
      "Magnesiummangel",
      "Wetterumschwünge"
    ],
    remedies: [
      { name: "Pfefferminzöl", benefit: "Wirkt kühlend und schmerzlindernd – klinisch belegt so wirksam wie Paracetamol", application: "Verdünnt auf Stirn und Schläfen auftragen, Augenkontakt vermeiden" },
      { name: "Magnesium", benefit: "Entspannt Muskeln und Blutgefäße, beugt Kopfschmerzen vor", application: "300-400mg täglich, besonders abends einnehmen" },
      { name: "Weidenrinde", benefit: "Natürliches Schmerzmittel mit aspirinähnlicher Wirkung", application: "Als Tee oder Extrakt bei akuten Kopfschmerzen" },
      { name: "Ingwer", benefit: "Entzündungshemmend, besonders wirksam bei Migräne", application: "Frischer Ingwertee oder Ingwerpulver (1/4 TL) mit Wasser" },
      { name: "Lavendel", benefit: "Beruhigend und entspannend bei stressbedingten Kopfschmerzen", application: "Als Aromatherapie oder Schläfenmassage mit Lavendelöl" }
    ],
    tips: [
      "Sofort ein großes Glas Wasser trinken",
      "Kurze Pause mit geschlossenen Augen in dunklem Raum",
      "Nacken und Schultern dehnen und lockern",
      "Frische Luft und leichte Bewegung",
      "Koffein kann bei beginnenden Kopfschmerzen helfen"
    ],
    whenToSeeDoctor: [
      "Plötzliche, extrem starke Kopfschmerzen (Vernichtungskopfschmerz)",
      "Kopfschmerzen mit Fieber, Nackensteife oder Sehstörungen",
      "Kopfschmerzen nach Kopfverletzung",
      "Chronische Kopfschmerzen mehr als 15 Tage im Monat"
    ],
    faqs: [
      { question: "Wie schnell wirkt Pfefferminzöl bei Kopfschmerzen?", answer: "Pfefferminzöl wirkt meist innerhalb von 15-30 Minuten. Die kühlende Wirkung ist sofort spürbar und die Schmerzlinderung setzt kurz darauf ein." },
      { question: "Kann Magnesium Kopfschmerzen vorbeugen?", answer: "Ja, Studien zeigen, dass regelmäßige Magnesiumeinnahme die Häufigkeit von Kopfschmerzen und Migräne um bis zu 40% reduzieren kann." },
      { question: "Welcher Kopfschmerztyp reagiert am besten auf Naturmittel?", answer: "Spannungskopfschmerzen sprechen besonders gut auf Naturmittel an. Bei Migräne helfen besonders Magnesium, Ingwer und Pestwurz." }
    ],
    relatedTopics: ["stress", "schlafprobleme", "fieber", "erkaeltung"]
  },

  "schlafprobleme": {
    slug: "schlafprobleme",
    title: "Schlafprobleme natürlich behandeln",
    metaTitle: "Schlafprobleme natürlich lösen: Die besten Hausmittel zum Einschlafen | Naturkraft",
    metaDescription: "Endlich besser schlafen ohne Schlaftabletten. Baldrian, Melatonin & bewährte Einschlaftipps – natürlich und ohne Abhängigkeit.",
    h1: "Schlafprobleme natürlich behandeln: So findest du endlich erholsamen Schlaf",
    intro: "Millionen Menschen leiden unter Schlafproblemen – vom Einschlafen bis zum Durchschlafen. Die Natur bietet sanfte, aber wirksame Alternativen zu verschreibungspflichtigen Schlafmitteln, die nicht abhängig machen.",
    causes: [
      "Stress und kreisende Gedanken",
      "Unregelmäßiger Schlafrhythmus",
      "Bildschirmnutzung vor dem Schlafen (Blaulicht)",
      "Koffein und Alkohol am Abend",
      "Hormonelle Veränderungen (Wechseljahre)",
      "Magnesiummangel"
    ],
    remedies: [
      { name: "Baldrian", benefit: "Das bekannteste pflanzliche Schlafmittel, verbessert Schlafqualität", application: "30-60 Minuten vor dem Schlafengehen einnehmen, Wirkung nach 2-4 Wochen optimal" },
      { name: "Melatonin", benefit: "Das körpereigene Schlafhormon, reguliert den Schlaf-Wach-Rhythmus", application: "0,5-1mg ca. 30 Minuten vor dem Schlafengehen" },
      { name: "Passionsblume", benefit: "Beruhigend und angstlösend, ideal bei Gedankenkreisen", application: "Als Tee oder Extrakt am Abend" },
      { name: "Lavendel", benefit: "Entspannend und schlaffördernd, wissenschaftlich belegt", application: "Als Kissenspray, Badezusatz oder in Kapselform" },
      { name: "Magnesium", benefit: "Entspannt Muskeln und Nervensystem, fördert Tiefschlaf", application: "300-400mg etwa 1 Stunde vor dem Schlafen" }
    ],
    tips: [
      "Feste Schlafenszeit – auch am Wochenende",
      "Schlafzimmer kühl, dunkel und ruhig halten",
      "Keine Bildschirme 1 Stunde vor dem Schlafen",
      "Entspannungsrituale wie Lesen oder leichte Dehnung",
      "Kein Koffein nach 14 Uhr"
    ],
    whenToSeeDoctor: [
      "Schlafprobleme dauern länger als 4 Wochen",
      "Starke Tagesmüdigkeit beeinträchtigt den Alltag",
      "Verdacht auf Schlafapnoe (Schnarchen mit Atemaussetzern)",
      "Restless-Legs-Syndrom (Unruhe in den Beinen)"
    ],
    faqs: [
      { question: "Macht Baldrian abhängig?", answer: "Nein, Baldrian macht nicht abhängig und hat keinen Gewöhnungseffekt. Es kann bedenkenlos über längere Zeit eingenommen werden." },
      { question: "Wie lange dauert es, bis Naturmittel beim Schlafen wirken?", answer: "Melatonin wirkt meist sofort, Baldrian und Passionsblume entfalten ihre volle Wirkung nach 2-4 Wochen regelmäßiger Einnahme." },
      { question: "Kann ich mehrere Schlafmittel kombinieren?", answer: "Ja, Kombinationen wie Baldrian + Hopfen oder Passionsblume + Lavendel sind sinnvoll und verstärken die Wirkung." }
    ],
    relatedTopics: ["stress", "muedigkeit", "kopfschmerzen", "abnehmen"]
  },

  "abnehmen": {
    slug: "abnehmen",
    title: "Natürlich abnehmen",
    metaTitle: "Natürlich abnehmen: Stoffwechsel ankurbeln mit Hausmitteln | Naturkraft",
    metaDescription: "Gesund abnehmen ohne Crash-Diät. Grüner Tee, Glucomannan & natürliche Fatburner – wissenschaftlich belegt und nachhaltig wirksam.",
    h1: "Natürlich abnehmen: Diese Naturmittel unterstützen deinen Stoffwechsel",
    intro: "Abnehmen ist keine Frage von Wunderpillen, sondern von nachhaltigem Lebensstil. Naturmittel können diesen Prozess jedoch effektiv unterstützen – indem sie den Stoffwechsel ankurbeln, Heißhunger reduzieren und die Fettverbrennung fördern.",
    causes: [
      "Langsamer Stoffwechsel",
      "Heißhungerattacken und emotionales Essen",
      "Bewegungsmangel im Alltag",
      "Hormonelle Ungleichgewichte",
      "Stress erhöht Cortisol und fördert Bauchfett",
      "Schlafmangel beeinflusst Hungerhormone"
    ],
    remedies: [
      { name: "Grüner Tee", benefit: "Kurbelt Stoffwechsel an, fördert Fettverbrennung um bis zu 4%", application: "3-4 Tassen täglich, am besten vor den Mahlzeiten" },
      { name: "Glucomannan", benefit: "Quellstoff aus der Konjak-Wurzel, sättigt natürlich ohne Kalorien", application: "Mit viel Wasser vor den Mahlzeiten einnehmen" },
      { name: "Chrom", benefit: "Reguliert Blutzucker, reduziert Heißhunger auf Süßes", application: "200-400mcg täglich zu den Mahlzeiten" },
      { name: "Ingwer", benefit: "Thermogen – steigert Kalorienverbrennung, fördert Verdauung", application: "Frischer Ingwertee oder zu Mahlzeiten" },
      { name: "Apfelessig", benefit: "Stabilisiert Blutzucker, fördert Sättigungsgefühl", application: "1 EL verdünnt in Wasser vor den Mahlzeiten" }
    ],
    tips: [
      "Mehr Protein essen – sättigt länger und erhält Muskelmasse",
      "Wasser vor jeder Mahlzeit trinken",
      "Mehr Bewegung im Alltag (Treppen, Spazieren)",
      "Ausreichend schlafen – Schlafmangel fördert Heißhunger",
      "Stress reduzieren – Cortisol fördert Bauchfett"
    ],
    whenToSeeDoctor: [
      "Unerklärlicher Gewichtsverlust oder -zunahme",
      "Verdacht auf Schilddrüsenprobleme",
      "Essstörungen oder gestörtes Essverhalten",
      "Starkes Übergewicht (BMI über 35)"
    ],
    faqs: [
      { question: "Wie viel kann man mit Naturmitteln abnehmen?", answer: "Naturmittel sind keine Wundermittel, können aber den Gewichtsverlust um 10-20% steigern. In Kombination mit gesunder Ernährung und Bewegung ist ein nachhaltiger Verlust von 0,5-1kg pro Woche realistisch." },
      { question: "Hilft grüner Tee wirklich beim Abnehmen?", answer: "Ja, Studien zeigen, dass grüner Tee den Stoffwechsel um 3-4% steigern und die Fettverbrennung fördern kann. Der Effekt ist moderat, aber nachhaltig." },
      { question: "Ist Glucomannan sicher?", answer: "Ja, Glucomannan ist ein zugelassener Ballaststoff. Wichtig ist, es immer mit viel Wasser einzunehmen, da es stark quillt." }
    ],
    relatedTopics: ["verdauungsprobleme", "stress", "schlafprobleme", "muedigkeit"]
  },

  // ========== 10 NEUE RATGEBER ==========

  "grippe": {
    slug: "grippe",
    title: "Grippe natürlich behandeln",
    metaTitle: "Grippe natürlich behandeln: Schnelle Hilfe mit Hausmitteln | Naturkraft",
    metaDescription: "Grippe natürlich auskurieren mit bewährten Hausmitteln. Holunder, Echinacea & Co. – so wirst du schneller fit ohne starke Medikamente.",
    h1: "Grippe natürlich behandeln: So unterstützt du deinen Körper bei der Heilung",
    intro: "Die echte Grippe (Influenza) ist deutlich schwerer als eine Erkältung und wirft uns oft für 1-2 Wochen komplett aus der Bahn. Naturmittel können den Heilungsprozess unterstützen und die Symptome lindern – aber bei schweren Verläufen ist ärztliche Hilfe wichtig.",
    causes: [
      "Influenzaviren A, B oder C",
      "Tröpfcheninfektion durch Husten und Niesen",
      "Schmierinfektion über kontaminierte Oberflächen",
      "Geschwächtes Immunsystem erhöht die Anfälligkeit"
    ],
    remedies: [
      { name: "Holunderbeeren-Extrakt", benefit: "Kann Grippedauer um bis zu 4 Tage verkürzen (wissenschaftlich belegt)", application: "Bei ersten Symptomen hochdosiert einnehmen" },
      { name: "Echinacea", benefit: "Stärkt das Immunsystem und kann Komplikationen vorbeugen", application: "Als Tinktur oder Tabletten alle 2-3 Stunden" },
      { name: "Ingwer-Zitronen-Tee", benefit: "Wärmt, wirkt antiviral und lindert Gliederschmerzen", application: "Frisch aufgebrüht mit Honig mehrmals täglich" },
      { name: "Lindenblütentee", benefit: "Schweißtreibend, hilft dem Körper Giftstoffe auszuscheiden", application: "3-4 Tassen täglich, warm trinken" },
      { name: "Vitamin D3", benefit: "Stärkt Immunabwehr, besonders im Winter oft mangelhaft", application: "2000-4000 IE täglich während der Grippe" }
    ],
    tips: [
      "Absolute Bettruhe – der Körper braucht alle Energie für die Heilung",
      "Mindestens 3 Liter Flüssigkeit täglich trinken",
      "Leichte Kost wie Brühen und gedünstetes Gemüse",
      "Zimmer regelmäßig lüften, aber Zugluft vermeiden",
      "Erst wieder Sport treiben, wenn 48 Stunden fieberfrei"
    ],
    whenToSeeDoctor: [
      "Fieber über 40°C oder Fieber das länger als 5 Tage dauert",
      "Atemnot oder Brustschmerzen",
      "Starke Benommenheit oder Verwirrtheit",
      "Bei Risikogruppen: Schwangere, Ältere, chronisch Kranke",
      "Symptome bessern sich nach einer Woche nicht"
    ],
    faqs: [
      { question: "Was ist der Unterschied zwischen Grippe und Erkältung?", answer: "Die Grippe beginnt plötzlich mit hohem Fieber, starken Gliederschmerzen und extremer Erschöpfung. Eine Erkältung entwickelt sich langsam mit Schnupfen und Halsschmerzen." },
      { question: "Wie lange ist man bei Grippe ansteckend?", answer: "Man ist etwa 1 Tag vor Symptombeginn bis 5-7 Tage danach ansteckend. Bei Kindern und Menschen mit schwachem Immunsystem kann es länger sein." },
      { question: "Kann man sich gegen Grippe natürlich schützen?", answer: "Ja, ein starkes Immunsystem durch ausreichend Schlaf, Vitamin D, Zink und Bewegung an der frischen Luft reduziert das Risiko deutlich." }
    ],
    relatedTopics: ["fieber", "erkaeltung", "husten", "immunsystem-staerken"]
  },

  "husten": {
    slug: "husten",
    title: "Husten natürlich lindern",
    metaTitle: "Husten natürlich lindern: Die besten Hausmittel gegen Reizhusten | Naturkraft",
    metaDescription: "Husten schnell loswerden mit natürlichen Mitteln. Thymian, Spitzwegerich & Honig – wirksam bei trockenem Husten und Schleim.",
    h1: "Husten natürlich lindern: Bewährte Hausmittel für jede Hustenart",
    intro: "Husten ist ein wichtiger Schutzreflex des Körpers – aber besonders nachts kann er sehr quälend sein. Die Natur bietet für jede Hustenart das passende Mittel: schleimlösend bei produktivem Husten, reizmildernd bei trockenem Husten.",
    causes: [
      "Virale Infektionen der Atemwege (häufigste Ursache)",
      "Trockene Heizungsluft reizt die Schleimhäute",
      "Allergien und Asthma",
      "Reflux von Magensäure",
      "Rauchen und Passivrauchen"
    ],
    remedies: [
      { name: "Thymian", benefit: "Stark schleimlösend und krampflösend, medizinisch anerkannt", application: "Als Tee oder Sirup 3-4x täglich" },
      { name: "Spitzwegerich", benefit: "Bildet Schutzfilm auf der Schleimhaut, lindert Reizhusten", application: "Als Sirup oder Tee bei trockenem Husten" },
      { name: "Honig", benefit: "Wissenschaftlich bewiesen wirksamer als viele Hustenmittel", application: "Pur oder in warmem Tee, nicht für Kinder unter 1 Jahr" },
      { name: "Eibischwurzel", benefit: "Schleimstoffe legen sich schützend auf gereizte Schleimhaut", application: "Als Kaltauszug oder Lutschtabletten" },
      { name: "Efeu-Extrakt", benefit: "Entspannt die Bronchien, löst festsitzenden Schleim", application: "Als Sirup oder Tropfen gemäß Packungsanweisung" }
    ],
    tips: [
      "Viel trinken – hält den Schleim flüssig und leichter abhustbar",
      "Luftfeuchtigkeit erhöhen (feuchte Tücher, Luftbefeuchter)",
      "Inhalieren mit Salzwasser oder Kamillenaufguss",
      "Oberkörper beim Schlafen erhöht lagern",
      "Bei Reizhusten: Lutschen von Bonbons fördert Speichelproduktion"
    ],
    whenToSeeDoctor: [
      "Husten dauert länger als 3 Wochen",
      "Blut im Auswurf",
      "Atemnot oder pfeifende Atemgeräusche",
      "Hohes Fieber über 39°C",
      "Husten bei Kindern unter 1 Jahr"
    ],
    faqs: [
      { question: "Soll man Husten unterdrücken?", answer: "Produktiven Husten mit Auswurf sollte man nicht unterdrücken, da der Körper so Schleim und Erreger loswird. Nur trockener Reizhusten ohne Funktion kann gelindert werden." },
      { question: "Ist Honig wirklich so wirksam bei Husten?", answer: "Ja, Studien zeigen, dass Honig bei Kindern über 1 Jahr wirksamer ist als viele konventionelle Hustenmittel – besonders bei nächtlichem Husten." },
      { question: "Welches Mittel bei trockenem vs. produktivem Husten?", answer: "Bei trockenem Reizhusten: Spitzwegerich, Eibisch, Honig. Bei produktivem Husten mit Schleim: Thymian, Efeu, Inhalation." }
    ],
    relatedTopics: ["erkaeltung", "grippe", "halsschmerzen", "immunsystem-staerken"]
  },

  "halsschmerzen": {
    slug: "halsschmerzen",
    title: "Halsschmerzen natürlich behandeln",
    metaTitle: "Halsschmerzen natürlich behandeln: Schnelle Hausmittel-Hilfe | Naturkraft",
    metaDescription: "Halsschmerzen schnell lindern mit bewährten Naturmitteln. Salbei, Honig & Salzwasser-Gurgeln – sofortige Hilfe bei Schluckbeschwerden.",
    h1: "Halsschmerzen natürlich behandeln: Diese Hausmittel wirken sofort",
    intro: "Kratzen im Hals, Schluckbeschwerden, Heiserkeit – Halsschmerzen sind oft das erste Zeichen einer nahenden Erkältung. Mit den richtigen Naturmitteln kannst du sie oft im Keim ersticken oder zumindest schnell lindern.",
    causes: [
      "Virusinfektionen (90% aller Fälle)",
      "Bakterielle Infektionen (z.B. Streptokokken)",
      "Trockene Luft und Überlastung der Stimme",
      "Allergien und Reizstoffe in der Luft",
      "Reflux von Magensäure"
    ],
    remedies: [
      { name: "Salbei", benefit: "Stark antibakteriell und entzündungshemmend, lindert sofort", application: "Als Gurgellösung oder Tee mehrmals täglich" },
      { name: "Salzwasser-Gurgeln", benefit: "Desinfiziert, lindert Schwellung, löst Schleim", application: "1 TL Salz auf 250ml warmes Wasser, 3-4x täglich gurgeln" },
      { name: "Honig", benefit: "Antibakteriell, legt sich schützend auf die Schleimhaut", application: "Pur löffeln oder in warmem Tee, langsam schlucken" },
      { name: "Propolis", benefit: "Natürliches Antibiotikum der Bienen, stark antimikrobiell", application: "Als Spray direkt in den Rachen oder als Tinktur" },
      { name: "Ingwer", benefit: "Wärmt, wirkt antimikrobiell und schmerzlindernd", application: "Frisch geschnitten kauen oder als heißer Tee" }
    ],
    tips: [
      "Viel warme Flüssigkeit trinken (nicht heiß!)",
      "Hals warmhalten mit Schal oder Wickel",
      "Stimme schonen, nicht flüstern (belastet mehr!)",
      "Lutschbonbons fördern die Speichelproduktion",
      "Kalte Getränke und Eis können kurzzeitig betäuben"
    ],
    whenToSeeDoctor: [
      "Halsschmerzen mit hohem Fieber über 39°C",
      "Weiße Beläge oder Eiter auf den Mandeln",
      "Starke Schluckbeschwerden, kein Trinken möglich",
      "Geschwollene Lymphknoten am Hals",
      "Halsschmerzen dauern länger als 7 Tage"
    ],
    faqs: [
      { question: "Helfen Halsschmerztabletten aus der Apotheke besser?", answer: "Nicht unbedingt. Studien zeigen, dass Salbei-Gurgeln und Honig oft genauso wirksam sind wie lokale Betäubungsmittel – ohne chemische Zusätze." },
      { question: "Warm oder kalt bei Halsschmerzen?", answer: "Beides kann helfen: Warme Getränke und Wickel fördern die Durchblutung und Heilung. Kälte (Eis, kalte Getränke) kann vorübergehend den Schmerz betäuben." },
      { question: "Wann muss man Antibiotika nehmen?", answer: "Nur bei nachgewiesener bakterieller Infektion (z.B. Streptokokken durch Abstrich). Bei viralen Halsschmerzen (90% der Fälle) helfen Antibiotika nicht." }
    ],
    relatedTopics: ["erkaeltung", "husten", "fieber", "immunsystem-staerken"]
  },

  "verdauungsprobleme": {
    slug: "verdauungsprobleme",
    title: "Verdauungsprobleme natürlich behandeln",
    metaTitle: "Verdauungsprobleme natürlich lösen: Hausmittel für Magen & Darm | Naturkraft",
    metaDescription: "Verdauung natürlich anregen mit bewährten Hausmitteln. Fenchel, Flohsamen & mehr – bei Blähungen, Verstopfung und Magenbeschwerden.",
    h1: "Verdauungsprobleme natürlich behandeln: Sanfte Hilfe für Magen und Darm",
    intro: "Blähungen, Verstopfung, Durchfall oder Magenschmerzen – Verdauungsprobleme können den Alltag stark beeinträchtigen. Die Naturheilkunde kennt für jede Beschwerde wirksame und sanfte Mittel ohne Nebenwirkungen.",
    causes: [
      "Ballaststoffarme Ernährung und zu wenig Flüssigkeit",
      "Stress und Hektik beim Essen",
      "Unverträglichkeiten (Laktose, Gluten, Fruktose)",
      "Gestörte Darmflora nach Antibiotika",
      "Bewegungsmangel verlangsamt die Darmtätigkeit"
    ],
    remedies: [
      { name: "Fenchel-Kümmel-Anis Tee", benefit: "Löst Blähungen, entspannt Darmmuskulatur", application: "1-2 Tassen nach den Mahlzeiten" },
      { name: "Flohsamenschalen", benefit: "Regulieren sowohl Verstopfung als auch Durchfall", application: "1-2 TL mit 200ml Wasser, viel nachtrinken" },
      { name: "Ingwer", benefit: "Regt Verdauung an, lindert Übelkeit und Magenkrämpfe", application: "Vor den Mahlzeiten als Tee oder frisch gekaut" },
      { name: "Pfefferminzöl", benefit: "Entspannt verkrampfte Darmmuskulatur, lindert Reizdarm", application: "Als magensaftresistente Kapseln oder Tee" },
      { name: "Probiotika", benefit: "Bauen gesunde Darmflora auf, stärken Immunsystem", application: "Täglich als Präparat oder fermentierte Lebensmittel" }
    ],
    tips: [
      "Langsam essen und gründlich kauen",
      "Mindestens 2 Liter Wasser täglich trinken",
      "Ballaststoffreiche Ernährung schrittweise steigern",
      "Regelmäßige Bewegung fördert die Darmmotilität",
      "Stress reduzieren – der Darm ist das zweite Gehirn"
    ],
    whenToSeeDoctor: [
      "Blut im Stuhl oder schwarzer Stuhl",
      "Unerklärlicher Gewichtsverlust",
      "Starke, anhaltende Bauchschmerzen",
      "Verdauungsbeschwerden mit Fieber",
      "Verstopfung oder Durchfall länger als 2 Wochen"
    ],
    faqs: [
      { question: "Wie lange dauert es, bis Probiotika wirken?", answer: "Erste Verbesserungen zeigen sich oft nach 2-4 Wochen. Für einen nachhaltigen Aufbau der Darmflora sollten Probiotika mindestens 8-12 Wochen eingenommen werden." },
      { question: "Helfen Flohsamen bei Verstopfung UND Durchfall?", answer: "Ja, das ist ihre besondere Eigenschaft: Bei Verstopfung quellen sie und fördern den Stuhlgang. Bei Durchfall binden sie überschüssige Flüssigkeit und dicken den Stuhl ein." },
      { question: "Welche Lebensmittel fördern die Verdauung natürlich?", answer: "Besonders gut: Sauerkraut, Joghurt, Kefir (Probiotika), Leinsamen, Vollkornprodukte, Pflaumen und ausreichend Flüssigkeit." }
    ],
    relatedTopics: ["abnehmen", "stress", "immunsystem-staerken", "muedigkeit"]
  },

  "stress": {
    slug: "stress",
    title: "Stress natürlich abbauen",
    metaTitle: "Stress natürlich abbauen: Die besten pflanzlichen Beruhigungsmittel | Naturkraft",
    metaDescription: "Stress und innere Unruhe natürlich lindern. Ashwagandha, Baldrian & bewährte Entspannungstipps – ohne Abhängigkeit und Nebenwirkungen.",
    h1: "Stress natürlich abbauen: Pflanzliche Hilfe für mehr innere Ruhe",
    intro: "Chronischer Stress macht krank – körperlich und seelisch. Die Natur bietet sanfte, aber wirksame Adaptogene und Heilpflanzen, die dem Körper helfen, besser mit Stress umzugehen und die innere Balance wiederzufinden.",
    causes: [
      "Beruflicher Druck und ständige Erreichbarkeit",
      "Familiäre Belastungen und Mehrfachverantwortung",
      "Finanzielle Sorgen",
      "Schlafmangel verstärkt Stressempfinden",
      "Perfektionismus und zu hohe Erwartungen"
    ],
    remedies: [
      { name: "Ashwagandha", benefit: "Adaptogen – hilft dem Körper, sich an Stress anzupassen, senkt Cortisol", application: "300-600mg Extrakt täglich, morgens oder abends" },
      { name: "Rhodiola rosea", benefit: "Steigert Stressresistenz und mentale Leistungsfähigkeit", application: "200-400mg morgens auf nüchternen Magen" },
      { name: "Baldrian", benefit: "Beruhigt das Nervensystem, fördert Entspannung", application: "Als Tee oder Extrakt bei akutem Stress" },
      { name: "Lavendel", benefit: "Wissenschaftlich belegt angstlösend und beruhigend", application: "Als Kapsel (Silexan) oder Aromatherapie" },
      { name: "Passionsblume", benefit: "Löst innere Anspannung und kreisende Gedanken", application: "Als Tee oder Extrakt, auch tagsüber geeignet" }
    ],
    tips: [
      "Tägliche Bewegung baut Stresshormone ab",
      "Tiefe Bauchatmung aktiviert den Parasympathikus",
      "Digital Detox – regelmäßige Handypausen",
      "Feste Entspannungsrituale etablieren",
      "Nein-Sagen lernen und Grenzen setzen"
    ],
    whenToSeeDoctor: [
      "Anhaltende Erschöpfung trotz Ruhe",
      "Depressive Verstimmungen oder Angststörungen",
      "Körperliche Symptome wie Herzrasen, Schwindel",
      "Suchtverhalten als Stressbewältigung",
      "Sozialer Rückzug und Interessenverlust"
    ],
    faqs: [
      { question: "Wie lange dauert es, bis Ashwagandha wirkt?", answer: "Erste Effekte zeigen sich nach 2-4 Wochen. Die volle Wirkung entfaltet sich nach 8-12 Wochen regelmäßiger Einnahme." },
      { question: "Kann man Adaptogene langfristig nehmen?", answer: "Ja, Adaptogene wie Ashwagandha oder Rhodiola sind für die Langzeiteinnahme geeignet. Manche empfehlen Pausen (8 Wochen Einnahme, 2 Wochen Pause)." },
      { question: "Welches Mittel bei akutem Stress vs. chronischem Stress?", answer: "Bei akutem Stress: Baldrian, Passionsblume, Atemübungen. Bei chronischem Stress: Adaptogene wie Ashwagandha oder Rhodiola für langfristige Anpassung." }
    ],
    relatedTopics: ["schlafprobleme", "kopfschmerzen", "muedigkeit", "verdauungsprobleme"]
  },

  "immunsystem-staerken": {
    slug: "immunsystem-staerken",
    title: "Immunsystem natürlich stärken",
    metaTitle: "Immunsystem stärken: Die besten natürlichen Mittel zur Abwehr | Naturkraft",
    metaDescription: "Immunsystem natürlich aufbauen mit Vitamin D, Zink & Echinacea. Bewährte Tipps für starke Abwehrkräfte – besonders in der Erkältungszeit.",
    h1: "Immunsystem natürlich stärken: So machst du deine Abwehr winterfest",
    intro: "Ein starkes Immunsystem ist der beste Schutz vor Infektionen. Mit den richtigen Nährstoffen, Heilpflanzen und Lebensgewohnheiten kannst du deine körpereigene Abwehr gezielt unterstützen – ganz natürlich und ohne Nebenwirkungen.",
    causes: [
      "Vitamin D-Mangel besonders im Winter",
      "Zinkmangel schwächt die Immunzellen",
      "Chronischer Stress erhöht Infektanfälligkeit",
      "Schlafmangel reduziert Immunaktivität um bis zu 70%",
      "Unausgewogene Ernährung mit wenig Vitalstoffen"
    ],
    remedies: [
      { name: "Vitamin D3", benefit: "Aktiviert Immunzellen, essentiell für die Abwehr", application: "1000-4000 IE täglich, besonders im Winter" },
      { name: "Zink", benefit: "Verkürzt Erkältungsdauer, stärkt die Immunbarriere", application: "15-25mg täglich, bei Erkältung kurzzeitig höher" },
      { name: "Echinacea", benefit: "Steigert die Aktivität der Immunzellen nachweislich", application: "Kurweise 2-3 Wochen, dann Pause" },
      { name: "Beta-Glucane", benefit: "Trainieren das Immunsystem, erhöhen Wachsamkeit", application: "250-500mg täglich aus Hefe oder Pilzen" },
      { name: "Schwarzkümmelöl", benefit: "Immunmodulierend und entzündungshemmend", application: "1 TL täglich pur oder in Speisen" }
    ],
    tips: [
      "7-8 Stunden Schlaf pro Nacht für optimale Immunfunktion",
      "Regelmäßige Bewegung an der frischen Luft",
      "Kalt-warm-Wechselduschen trainieren die Abwehr",
      "Stress reduzieren – Cortisol schwächt das Immunsystem",
      "Bunt essen – verschiedene Farben = verschiedene Antioxidantien"
    ],
    whenToSeeDoctor: [
      "Häufige wiederkehrende Infektionen (mehr als 4x/Jahr)",
      "Infektionen dauern ungewöhnlich lange",
      "Wunden heilen schlecht",
      "Ständige Müdigkeit und Erschöpfung",
      "Unerklärlicher Gewichtsverlust"
    ],
    faqs: [
      { question: "Wie viel Vitamin D braucht man für ein starkes Immunsystem?", answer: "Der Blutwert sollte bei 40-60 ng/ml liegen. Im Winter brauchen die meisten Menschen in Deutschland 2000-4000 IE täglich, um diesen Wert zu erreichen." },
      { question: "Kann man das Immunsystem überaktivieren?", answer: "Ein gesundes Immunsystem reguliert sich selbst. Natürliche Mittel wie Vitamin D und Zink überstimulieren nicht, sondern optimieren die Funktion. Nur bei Autoimmunerkrankungen ist Vorsicht geboten." },
      { question: "Wie lange dauert es, das Immunsystem aufzubauen?", answer: "Erste Verbesserungen zeigen sich nach 2-4 Wochen. Ein nachhaltig starkes Immunsystem entsteht durch kontinuierliche gute Gewohnheiten über Monate." }
    ],
    relatedTopics: ["erkaeltung", "grippe", "fieber", "muedigkeit"]
  },

  "gelenkschmerzen": {
    slug: "gelenkschmerzen",
    title: "Gelenkschmerzen natürlich lindern",
    metaTitle: "Gelenkschmerzen natürlich lindern: Hausmittel bei Arthrose & Co. | Naturkraft",
    metaDescription: "Gelenkschmerzen natürlich behandeln mit Kurkuma, Weihrauch & Omega-3. Bewährte Hausmittel bei Arthrose, Rheuma und steifen Gelenken.",
    h1: "Gelenkschmerzen natürlich lindern: Wirksame Alternativen zu Schmerzmitteln",
    intro: "Ob Arthrose, Rheuma oder Überlastung – Gelenkschmerzen schränken die Lebensqualität stark ein. Natürliche entzündungshemmende Mittel können Schmerzen lindern und die Beweglichkeit verbessern, oft mit weniger Nebenwirkungen als klassische Schmerzmittel.",
    causes: [
      "Verschleiß durch Alterung (Arthrose)",
      "Autoimmunbedingte Entzündungen (Rheuma)",
      "Überlastung durch Sport oder Beruf",
      "Übergewicht belastet die Gelenke zusätzlich",
      "Bewegungsmangel schwächt die stützende Muskulatur"
    ],
    remedies: [
      { name: "Kurkuma (Curcumin)", benefit: "Stark entzündungshemmend, so wirksam wie manche NSAR", application: "500-1000mg Curcumin-Extrakt mit Piperin, 2x täglich" },
      { name: "Weihrauch (Boswellia)", benefit: "Hemmt entzündliche Enzyme, schützt Knorpel", application: "300-500mg Extrakt, 3x täglich zu den Mahlzeiten" },
      { name: "Omega-3-Fettsäuren", benefit: "Reduzieren Gelenkentzündungen nachweislich", application: "2-3g EPA/DHA täglich aus Fischöl oder Algenöl" },
      { name: "MSM (Methylsulfonylmethan)", benefit: "Schwefelquelle für Knorpel und Bindegewebe", application: "1500-3000mg täglich in geteilten Dosen" },
      { name: "Teufelskralle", benefit: "Traditionelles Mittel bei Gelenkbeschwerden", application: "Als Extrakt oder Tee, Wirkung nach 4-8 Wochen" }
    ],
    tips: [
      "Sanfte Bewegung erhält die Gelenkschmiere (Schwimmen, Radfahren)",
      "Wärme bei chronischen Schmerzen, Kälte bei akuten Entzündungen",
      "Übergewicht reduzieren – jedes Kilo weniger entlastet",
      "Entzündungsfördernde Lebensmittel meiden (Zucker, Weißmehl)",
      "Muskelaufbau stabilisiert und entlastet Gelenke"
    ],
    whenToSeeDoctor: [
      "Plötzliche starke Gelenkschmerzen mit Rötung und Schwellung",
      "Fieber zusammen mit Gelenkschmerzen",
      "Gelenkschmerzen nach Verletzung oder Unfall",
      "Morgensteifigkeit über 30 Minuten (Rheuma-Verdacht)",
      "Schmerzen werden trotz Maßnahmen schlimmer"
    ],
    faqs: [
      { question: "Kann man Arthrose natürlich stoppen?", answer: "Arthrose ist nicht heilbar, aber der Verlauf kann verlangsamt werden. Studien zeigen, dass Kurkuma und Omega-3 die Entzündung reduzieren und den Knorpelabbau bremsen können." },
      { question: "Wie lange bis Kurkuma bei Gelenkschmerzen wirkt?", answer: "Erste Verbesserungen nach 4-8 Wochen. Wichtig: Curcumin wird nur mit Piperin (schwarzer Pfeffer) gut aufgenommen. Auf hochwertige Extrakte achten." },
      { question: "Helfen Naturmittel auch bei Rheuma?", answer: "Ja, besonders Omega-3, Kurkuma und Weihrauch können bei entzündlichem Rheuma die Symptome lindern. Sie ersetzen aber keine ärztliche Behandlung bei Autoimmunerkrankungen." }
    ],
    relatedTopics: ["kopfschmerzen", "muedigkeit", "stress", "abnehmen"]
  },

  "allergie": {
    slug: "allergie",
    title: "Allergie natürlich lindern",
    metaTitle: "Allergie natürlich behandeln: Hausmittel gegen Heuschnupfen & Co. | Naturkraft",
    metaDescription: "Allergie-Symptome natürlich lindern mit Quercetin, Schwarzkümmel & lokaler Honig. Natürliche Hilfe bei Heuschnupfen ohne Müdigkeit.",
    h1: "Allergie natürlich behandeln: So linderst du Heuschnupfen ohne Nebenwirkungen",
    intro: "Juckende Augen, laufende Nase, Niesattacken – Allergien machen Millionen Menschen das Leben schwer. Natürliche Antihistaminika und Immunmodulatoren können Symptome lindern, ohne müde zu machen wie klassische Allergiemedikamente.",
    causes: [
      "Überreaktion des Immunsystems auf harmlose Stoffe",
      "Genetische Veranlagung (Atopie)",
      "Gestörte Darmflora kann Allergien fördern",
      "Frühe Antibiotika-Gabe im Kindesalter",
      "Übertriebene Hygiene (Hygiene-Hypothese)"
    ],
    remedies: [
      { name: "Quercetin", benefit: "Natürliches Antihistaminikum, stabilisiert Mastzellen", application: "500-1000mg täglich, am besten vorbeugend vor der Saison" },
      { name: "Schwarzkümmelöl", benefit: "Reguliert Immunreaktion, lindert Heuschnupfen-Symptome", application: "1-2 TL täglich oder 500mg Kapseln" },
      { name: "Lokaler Honig", benefit: "Kann bei regelmäßiger Einnahme Toleranz aufbauen", application: "Täglich 1 TL regionaler Honig, Monate vor der Saison beginnen" },
      { name: "Brennnessel", benefit: "Wirkt natürlich antihistaminisch", application: "Als Tee oder Extrakt bei akuten Symptomen" },
      { name: "Vitamin C", benefit: "Senkt Histaminspiegel, unterstützt Immunsystem", application: "1-2g täglich in geteilten Dosen" }
    ],
    tips: [
      "Nasendusche mit Salzwasser spült Pollen aus",
      "Haare waschen vor dem Schlafengehen (Pollen entfernen)",
      "Pollenschutzgitter an Fenstern anbringen",
      "Wäsche nicht draußen trocknen während der Pollenzeit",
      "Darmflora aufbauen – 70% des Immunsystems sitzt im Darm"
    ],
    whenToSeeDoctor: [
      "Atemnot oder asthmatische Beschwerden",
      "Allergie-Symptome beeinträchtigen den Alltag stark",
      "Verdacht auf Lebensmittel- oder Medikamentenallergie",
      "Anaphylaktische Reaktionen in der Vorgeschichte",
      "Symptome sprechen nicht auf Selbstbehandlung an"
    ],
    faqs: [
      { question: "Wie früh muss man mit natürlichen Mitteln beginnen?", answer: "Für beste Wirkung 4-6 Wochen vor Beginn der Allergiesaison mit Quercetin und Schwarzkümmelöl beginnen. Lokaler Honig wirkt besser, wenn man Monate vorher startet." },
      { question: "Kann man Allergien natürlich heilen?", answer: "Eine vollständige Heilung ist selten, aber die Symptome können deutlich reduziert werden. Manche Menschen berichten, dass ihre Allergien durch Darmaufbau und Lebenstiländerung verschwunden sind." },
      { question: "Sind natürliche Antihistaminika so wirksam wie Medikamente?", answer: "Sie wirken meist milder, haben dafür aber keine Nebenwirkungen wie Müdigkeit. Bei schweren Allergien können sie Medikamente ergänzen, aber nicht immer ersetzen." }
    ],
    relatedTopics: ["immunsystem-staerken", "husten", "verdauungsprobleme", "hautprobleme"]
  },

  "muedigkeit": {
    slug: "muedigkeit",
    title: "Müdigkeit natürlich bekämpfen",
    metaTitle: "Müdigkeit natürlich bekämpfen: Mehr Energie ohne Koffein | Naturkraft",
    metaDescription: "Chronische Müdigkeit überwinden mit natürlichen Mitteln. Vitamin B12, Eisen & Adaptogene – nachhaltige Energie statt kurzfristiger Aufputscher.",
    h1: "Müdigkeit natürlich bekämpfen: So bekommst du nachhaltig mehr Energie",
    intro: "Ständig müde trotz genug Schlaf? Chronische Erschöpfung kann viele Ursachen haben. Natürliche Energiegeber und die Behebung von Nährstoffmängeln können nachhaltig mehr Vitalität bringen – ohne den Crash, den Kaffee und Energy-Drinks verursachen.",
    causes: [
      "Eisenmangel (häufigste Ursache bei Frauen)",
      "Vitamin B12-Mangel, besonders bei Vegetariern/Veganern",
      "Vitamin D-Mangel verstärkt Müdigkeit",
      "Schlafstörungen und schlechte Schlafqualität",
      "Chronischer Stress und Burnout",
      "Schilddrüsenunterfunktion"
    ],
    remedies: [
      { name: "Vitamin B12", benefit: "Essentiell für Energiestoffwechsel und Nervenfunktion", application: "500-1000mcg täglich, bei Mangel höher dosiert" },
      { name: "Eisen (wenn Mangel besteht)", benefit: "Sauerstofftransport, ohne Eisen keine Energie", application: "Nach Bluttest dosieren, mit Vitamin C einnehmen" },
      { name: "Rhodiola rosea", benefit: "Adaptogen gegen Erschöpfung, steigert mentale Energie", application: "200-400mg morgens auf nüchternen Magen" },
      { name: "Coenzym Q10", benefit: "Cellular Energieproduktion, besonders ab 40 sinnvoll", application: "100-200mg täglich zu einer fetthaltigen Mahlzeit" },
      { name: "Guarana", benefit: "Sanftes Koffein mit langsamer, gleichmäßiger Freisetzung", application: "Morgens als Alternative zu Kaffee, nicht abends" }
    ],
    tips: [
      "Blutwerte checken lassen (Eisen, B12, Vitamin D, Schilddrüse)",
      "Schlafrhythmus optimieren – auch am Wochenende gleich",
      "Bewegung gibt Energie – auch wenn man müde ist",
      "Blutzucker stabil halten (keine Zuckerspitzen)",
      "Mittagsschlaf maximal 20 Minuten (Power Nap)"
    ],
    whenToSeeDoctor: [
      "Extreme Müdigkeit trotz ausreichend Schlaf",
      "Müdigkeit zusammen mit unerklärlichem Gewichtsverlust",
      "Begleitende Symptome wie Haarausfall oder Kälteempfindlichkeit",
      "Müdigkeit nach Infektionen (Post-Viral-Fatigue)",
      "Müdigkeit beeinträchtigt Arbeits- oder Alltagsleben"
    ],
    faqs: [
      { question: "Wie merke ich, ob ich einen Nährstoffmangel habe?", answer: "Bluttest beim Arzt: Wichtig sind Ferritin (Eisenspeicher, nicht nur Hämoglobin), Vitamin B12, Vitamin D und Schilddrüsenwerte (TSH). Viele Menschen haben subklinische Mängel." },
      { question: "Warum bin ich trotz Schlaf müde?", answer: "Häufige Gründe: Schlafapnoe, gestörte Schlafarchitektur, Nährstoffmängel oder chronischer Stress. Auch die Schlafqualität zählt, nicht nur die Dauer." },
      { question: "Sind Energy Drinks okay?", answer: "Kurzfristig geben sie Energie, aber der Crash danach und die Belastung des Kreislaufs machen sie langfristig kontraproduktiv. Natürliche Alternativen sind nachhaltiger." }
    ],
    relatedTopics: ["schlafprobleme", "stress", "immunsystem-staerken", "abnehmen"]
  },

  "hautprobleme": {
    slug: "hautprobleme",
    title: "Hautprobleme natürlich behandeln",
    metaTitle: "Hautprobleme natürlich behandeln: Hausmittel bei Akne, Ekzem & Co. | Naturkraft",
    metaDescription: "Hautprobleme natürlich lindern mit Zink, Aloe Vera & Teebaumöl. Sanfte Hilfe bei Akne, Neurodermitis und unreiner Haut.",
    h1: "Hautprobleme natürlich behandeln: Sanfte Hilfe von innen und außen",
    intro: "Akne, Ekzeme, Neurodermitis oder einfach unreine Haut – Hautprobleme haben oft innere Ursachen. Die Naturheilkunde setzt deshalb auf Behandlung von innen (Darm, Ernährung) und außen (sanfte Pflege) für nachhaltige Verbesserung.",
    causes: [
      "Hormonelle Schwankungen (Pubertät, Zyklus, Wechseljahre)",
      "Gestörte Darmflora beeinflusst die Haut (Darm-Haut-Achse)",
      "Nährstoffmängel (Zink, Omega-3, Vitamin A)",
      "Stress erhöht entzündliche Hautreaktionen",
      "Unverträglichkeiten (Milch, Gluten können Akne verschlimmern)"
    ],
    remedies: [
      { name: "Zink", benefit: "Reguliert Talgproduktion, wirkt antibakteriell", application: "15-30mg täglich, besonders bei Akne" },
      { name: "Omega-3-Fettsäuren", benefit: "Entzündungshemmend, verbessern Hautbarriere", application: "2-3g EPA/DHA täglich aus Fisch- oder Algenöl" },
      { name: "Teebaumöl", benefit: "Antibakteriell, wirksam bei Akne wie 5% Benzoylperoxid", application: "Verdünnt (5%) auf betroffene Stellen tupfen" },
      { name: "Aloe Vera", benefit: "Beruhigt, heilt und spendet Feuchtigkeit", application: "Reines Gel aus der Pflanze oder Bioprodukt auftragen" },
      { name: "Nachtkerzenöl", benefit: "Gamma-Linolensäure verbessert Neurodermitis deutlich", application: "2-4g täglich oral oder als Creme" }
    ],
    tips: [
      "Darmgesundheit prüfen – Probiotika können Haut verbessern",
      "Milchprodukte probeweise weglassen (2-4 Wochen)",
      "Viel Wasser trinken für Hautfeuchtigkeit von innen",
      "Sanfte, pH-neutrale Reinigung ohne Sulfate",
      "Hände vom Gesicht – Bakterien nicht verteilen"
    ],
    whenToSeeDoctor: [
      "Starke Akne mit Narbenbildung",
      "Plötzliche Hautveränderungen oder neue Muttermale",
      "Juckende Ausschläge, die nicht weggehen",
      "Hautinfektionen mit Eiter oder Fieber",
      "Neurodermitis-Schübe, die nicht kontrollierbar sind"
    ],
    faqs: [
      { question: "Hängen Darm und Haut wirklich zusammen?", answer: "Ja, die Darm-Haut-Achse ist wissenschaftlich belegt. Eine gestörte Darmflora kann Entzündungen fördern, die sich als Akne, Rosacea oder Ekzeme zeigen. Probiotika können helfen." },
      { question: "Wie lange dauert es, bis sich die Haut bessert?", answer: "Die Haut erneuert sich alle 28 Tage. Realistische Verbesserungen zeigen sich nach 4-8 Wochen konsequenter Behandlung. Geduld ist wichtig!" },
      { question: "Ist Teebaumöl für alle Hauttypen geeignet?", answer: "Teebaumöl kann empfindliche Haut reizen. Immer erst verdünnt testen. Bei Neurodermitis oder sehr sensibler Haut eher meiden und sanftere Alternativen wie Aloe Vera wählen." }
    ],
    relatedTopics: ["allergie", "verdauungsprobleme", "stress", "abnehmen"]
  }
};

export const getRatgeberBySlug = (slug: string): RatgeberContent | undefined => {
  return ratgeberData[slug];
};

export const getAllRatgeberSlugs = (): string[] => {
  return Object.keys(ratgeberData);
};
